import {
  BasketballEventType,
  BasketballEventUserRoleType,
  BasketballGameJudgeSuggestionStatus,
} from '@hefe/models';

export const colors = {
  blue: '#2980b9',
  darkblue: '#273c75',
  primary: '#006266',
  secondary: '#FF8945',
  background: '#ffffff',
  brown: '#946F5C',
  green: '#27ae60',
  grey: '#7f8c8d',
  darkgrey: '#324B4C',
  lightgrey: '#ECECEC',
  purple: '#8e44ad',
  red: '#eb3b5a',
  lightred: '#eb3b5a1e',
  yellow: '#f1c40f',
  orange: '#FF8945',
};

export const BasketballEventColor = {
  GAME: colors.secondary,
  PRACTICE: colors.darkblue,
  JUDGE: colors.blue,
  REFEREE: colors.grey,
  EVENT: colors.purple,
  JERSEYS: colors.green,
  CANCELED: colors.red,
  TASK: colors.green,
};

export const getBasketballEventColor = (type: BasketballEventType) => {
  switch (type) {
    case BasketballEventType.GAME:
      return BasketballEventColor.GAME;
    case BasketballEventType.PRACTICE:
      return BasketballEventColor.PRACTICE;
    case BasketballEventType.JUDGE:
      return BasketballEventColor.JUDGE;
    case BasketballEventType.REFEREE:
      return BasketballEventColor.REFEREE;
    case BasketballEventType.EVENT:
      return BasketballEventColor.EVENT;
    case BasketballEventType.JERSEYS:
      return BasketballEventColor.JERSEYS;
    case BasketballEventType.TASK:
      return BasketballEventColor.TASK;
    default:
      return BasketballEventColor.GAME;
  }
};

export const getBasketballEventUserRoleColor = (
  type?: BasketballEventUserRoleType,
  eventType?: BasketballEventType
) => {
  switch (type) {
    case BasketballEventUserRoleType.PLAYER:
    case BasketballEventUserRoleType.COACH:
      return getBasketballEventColor(eventType ?? BasketballEventType.GAME);
    case BasketballEventUserRoleType.JUDGE:
      return BasketballEventColor.JUDGE;
    case BasketballEventUserRoleType.REFEREE:
      return BasketballEventColor.REFEREE;
    case BasketballEventUserRoleType.JERSEYS:
      return BasketballEventColor.JERSEYS;
    case BasketballEventUserRoleType.TASK:
      return BasketballEventColor.TASK;
    case BasketballEventUserRoleType.PARTICIPANT:
      return BasketballEventColor.EVENT;
    default:
      return BasketballEventColor.GAME;
  }
};

export function basketballGameJudgeSuggestionColor(
  status: BasketballGameJudgeSuggestionStatus
) {
  switch (status) {
    case BasketballGameJudgeSuggestionStatus.SAME_GYM:
      return '#46d246';
    case BasketballGameJudgeSuggestionStatus.NO_GAME:
      return '#c2f0c2';
    case BasketballGameJudgeSuggestionStatus.HOME_GAME:
      return '#ffffb3';
    case BasketballGameJudgeSuggestionStatus.AWAY_GAME:
      return '#ffb84d';
    case BasketballGameJudgeSuggestionStatus.SAME_TIME:
      return '#ff3333';
    case BasketballGameJudgeSuggestionStatus.THIS_GAME:
      return '#d24dff';
  }

  return '#ffffff';
}

export function isColorDark(color: string): boolean {
  // Convert the color to RGB format
  const rgbColor = hexToRgb(color);

  // Calculate the relative luminance of the color
  const luminance =
    (0.2126 * rgbColor.r + 0.7152 * rgbColor.g + 0.0722 * rgbColor.b) / 255;

  // Check if the luminance is below a threshold to determine if the color is dark
  return luminance < 0.5;
}

function hexToRgb(hex: string) {
  // Remove the '#' character from the hex color
  const hexWithoutHash = hex.replace('#', '');

  // Split the hex color into RGB components
  const r = parseInt(hexWithoutHash.substring(0, 2), 16);
  const g = parseInt(hexWithoutHash.substring(2, 4), 16);
  const b = parseInt(hexWithoutHash.substring(4, 6), 16);

  // Return the RGB color object
  return { r, g, b };
}
